import { render } from "./BienBanKiemNghiemPrintModal.vue?vue&type=template&id=52fa15b5&ts=true"
import script from "./BienBanKiemNghiemPrintModal.vue?vue&type=script&lang=ts"
export * from "./BienBanKiemNghiemPrintModal.vue?vue&type=script&lang=ts"

import "./BienBanKiemNghiemPrintModal.vue?vue&type=style&index=0&id=52fa15b5&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__